export default "__VITE_ASSET__3b09d948__"